const { validateContract } = require('./approval-contract')
const STATUS = {
  0: '草稿',
  10: '审批中',
  20: '退回修改',
  30: '待付款',
  40: '部分付款',
  50: '已结清',
  60: '已撤回',
}
// Date-only API fields must not depend on browser locale support or UTC conversion.
function dateOnly(value = new Date()) {
  const match = typeof value === 'string' ? value.trim().match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/) : null
  const parts = match ? match.slice(1).map(Number) : Object.prototype.toString.call(value) === '[object Date]' ? [value.getFullYear(), value.getMonth() + 1, value.getDate()] : []
  const [year, month, day] = parts
  if (!Number.isInteger(year) || year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1 || day > 31) return ''
  const date = new Date(year, month - 1, day)
  if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) return ''
  return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2)
}
function toCents(value) {
  const s = String(value === null || value === undefined ? '' : value).trim()
  if (!/^\d{1,9}(\.\d{1,2})?$/.test(s))
    throw new Error('金额须为不超过9位整数、最多两位小数的非负数')
  const parts = s.split('.')
  return Number(parts[0]) * 100 + Number(((parts[1] || '') + '00').slice(0, 2))
}
function totals(rows) {
  const total = (rows || []).reduce((sum, row) => sum + toCents(row.amount || '0'), 0)
  return { total: (total / 100).toFixed(2) }
}
function claimTotals(claim, rows) {
  if (claim.claimType === 'EXECUTIVE' && !(rows || []).length) {
    const raw = String(claim.totalAmount == null ? '' : claim.totalAmount).trim()
    return { total: raw ? (toCents(raw) / 100).toFixed(2) : '待填写' }
  }
  return totals(rows)
}
function files(value) {
  try {
    const data = Array.isArray(value) ? value : JSON.parse(value || '[]')
    return Array.isArray(data)
      ? data.map((f, i) =>
          Object.assign({}, f, { uid: f.uid || f.id || 'file-' + i }),
        )
      : []
  } catch (err) {
    return []
  }
}
function money(value) {
  const n = Number(value)
  return Number.isFinite(n)
    ? n.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : '0.00'
}
function amountPendingReview(c) { return c.amountPendingReview === true || (c.amountReviewMode === 'TOTAL' && c.originalAmountProvided === false && c.approvedAmount == null) }
function claimAmountText(c) { return amountPendingReview(c) ? '待核价' : money(c.approvedAmount == null ? c.totalAmount : c.approvedAmount) }
function claimStatusText(c) { return c.noPaymentRequired === true ? '无需付款' : STATUS[c.status] }
function wholeReview(c) { try { const r = JSON.parse(c.amountReviewJson || '{}'); return r.mode === 'TOTAL' ? r : null } catch (_) { return null } }
function pending(claim) {
  return [30, 40, 50].includes(Number(claim.status))
    ? (
        (toCents(claim.approvedAmount == null ? claim.totalAmount : claim.approvedAmount) - toCents(claim.paidAmount || '0')) /
        100
      ).toFixed(2)
    : null
}
function newItem() {
  return {
    category: '住宿费',
    description: '',
    amount: '',
    customerId: null,
    customerName: '',
    contactId: null,
    contactName: '',
    customerOptions: [],
    contactOptions: [],
    contractId: null,
    noContract: false,
    noContractReason: '',
    contractName: '',
    contractOptions: [],
    attachments: [],
  }
}
function validateClaim(claim, rows, submitting) {
  const required = (value) => String(value || '').trim().length > 0
  if (claim.claimType === 'EXECUTIVE') {
    if (!claim.beneficiaryId) throw Error('请选择报销人')
    if (!claim.deptId) throw Error('请选择所在部门')
    if (rows.length > 100) throw Error('费用明细最多100条')
    if (files(claim.imageFileObjs).length > 9) throw Error('图片最多9张')
    rows.forEach(x => { toCents(x.amount || '0') })
    const provided = claim.totalAmount != null && String(claim.totalAmount).trim() !== ''
    if (!rows.length && submitting && !provided) throw Error('无费用明细时请填写报销金额')
    const result = claimTotals(claim, rows)
    if (result.total !== '待填写') toCents(result.total)
    return result
  }
  if (!['NONE', 'PROJECT', 'NON_PROJECT'].includes(claim.procurementType || 'NONE')) throw Error('采购事项最多选择一项')
  if (!claim.payerCompanyId) throw Error('请选择支付公司')
  if (claim.budgetType === 'OUT' && !required(claim.budgetReason)) throw Error('请填写预算外原因')
  if (submitting && !required(claim.reason)) throw Error('请填写报销事由')
  if (submitting && !rows.length) throw Error('请添加费用明细')
  rows.forEach((x, i) => {
    const prefix = '第' + (i + 1) + '笔：'
    try { validateContract(x.contractId, x.noContract, x.noContractReason, submitting) } catch (e) { throw Error(prefix + e.message) }
    const amount = toCents(x.amount || '0')
    if (submitting && (!amount || !required(x.description))) throw Error(prefix + '请填写金额和费用说明')
    if (submitting && ['招待费', '业务招待'].includes(x.category) && !x.customerId && !required(x.customerName)) throw Error(prefix + '请选择或填写招待的客户')
    if (x.contactId && !x.customerId) throw Error(prefix + '请先选择客户')
  })
  const result = totals(rows)
  if (submitting && toCents(result.total) <= 0) throw Error('报销总额须大于0')
  return result
}

function claimFiles(claim) {
  return files((claim || {}).fileObjs)
}
function claimInput(claim, attachments) {
  const result = {}
  ;['claimType','reimbursementTypes','invoiceStatus','invoiceFileObjs','imageFileObjs','id','revision','beneficiaryId','payerCompanyId','budgetType','budgetReason','procurementType','deptId','reason'].forEach(k => { if (claim[k] !== undefined && (k !== 'invoiceStatus' || claim.claimType !== 'EXECUTIVE')) result[k] = claim[k] })
  if (claim.claimType === 'EXECUTIVE' && claim.totalAmount != null && String(claim.totalAmount).trim() !== '') result.totalAmount = claim.totalAmount
  result.fileObjs = JSON.stringify(attachments || [])
  return result
}
function itemInput(row) {
  const result = {}
  ;['category','description','customerId','customerName','contactId','productId','unmappedReason','contractId','noContract','noContractReason'].forEach(k => { if (row[k] !== undefined) result[k] = row[k] })
  result.fileObjs = JSON.stringify(row.attachments || files(row.fileObjs))
  result.amount = row.amount || '0'
  return result
}

function paymentCompanies(rows) {
  const list = rows || []
  const preferred = x => x.companyName === '南京瑞洁特膜分离科技有限公司'
  return list.filter(preferred).concat(list.filter(x => !preferred(x)))
}

function contractNumber(value) {
  return String(value || '').replace(/\s+\/.*$/, '').trim()
}

module.exports = {
  amountPendingReview, claimAmountText, claimStatusText, wholeReview, claimTotals,
  dateOnly,
  claimFiles,
  claimInput,
  itemInput,
  paymentCompanies,
  contractNumber,
  validateClaim,
  STATUS,
  toCents,
  totals,
  files,
  money,
  pending,
  newItem,
}
